import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { store } from "./store/index";
import reportWebVitals from './reportWebVitals';
import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faUser, faFileExcel, faPlus, faPrint, faEye, faCopy, faPenToSquare, 
  faTrashCan, faXmark, faFloppyDisk, faMagnifyingGlass, faXmarkCircle, 
  faImage, faCrown, faStore, faGear, faCamera, faPhone, faEnvelope, 
  faLocationDot, faLock, faUserShield, faReceipt, faChartLine, faBoxOpen,
  faCalendarDays, faFileLines, faLayerGroup, faFire, faBoxesStacked,
  faCoins, faTriangleExclamation, faWarehouse, faUserClock, faMoneyBillWave,
  faScaleBalanced, faClipboardList, faUsers, faCreditCard, faStar, faAward,
  faChartPie, faArrowsRotate, faDollarSign, faSackDollar, faTrophy, 
  faCalendarWeek, faChartSimple, faTableList, faRotateRight, faBell, faBolt,
  faTags, faClipboardCheck, faHandHoldingDollar, faClockRotateLeft, faFilter
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUser, faFileExcel, faPlus, faPrint, faEye, faCopy, faPenToSquare, 
  faTrashCan, faXmark, faFloppyDisk, faMagnifyingGlass, faXmarkCircle, 
  faImage, faCrown, faStore, faGear, faCamera, faPhone, faEnvelope, 
  faLocationDot, faLock, faUserShield, faReceipt, faChartLine, faBoxOpen,
  faCalendarDays, faFileLines, faLayerGroup, faFire, faBoxesStacked,
  faCoins, faTriangleExclamation, faWarehouse, faUserClock, faMoneyBillWave,
  faScaleBalanced, faClipboardList, faUsers, faCreditCard, faStar, faAward,
  faChartPie, faArrowsRotate, faDollarSign, faSackDollar, faTrophy, 
  faCalendarWeek, faChartSimple, faTableList, faRotateRight, faBell, faBolt,
  faTags, faClipboardCheck, faHandHoldingDollar, faClockRotateLeft, faFilter
)

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
